<template>
    <el-dialog :visible.sync="visible" width="760px" custom-class="onboarding-configure-dialog"
        :close-on-click-modal="false">
        <div class="onboarding-configure-body">
            <div class="configure-header">
                <div class="configure-header-left">
                    <div class="configure-icon">
                        <i class="bx bx-money"></i>
                    </div>
                    <div class="configure-text">
                        <div class="configure-title">Configura tu negocio</div>
                        <div class="configure-sub">Personaliza Samii para tu taller. Puedes hacerlo ahora o después.
                        </div>
                    </div>
                </div>
            </div>

            <div class="configure-grid">
                <div class="config-card">
                    <div class="card-icon"><i class="bx bx-image"></i></div>
                    <div class="card-body">
                        <div class="card-title">Sube tu logo</div>
                        <div class="card-desc">Personaliza tu marca subiendo el logo de tu negocio</div>
                        <el-button type="primary" class="card-btn" @click="openSettings('business', 'logo')">Configurar
                            <span class="arrow">→</span></el-button>
                    </div>
                </div>

                <div class="config-card">
                    <div class="card-icon"><i class="bx bx-money"></i></div>
                    <div class="card-body">
                        <div class="card-title">Configura impuestos</div>
                        <div class="card-desc">Define los impuestos aplicables a tus servicios y productos</div>
                        <el-button type="primary" class="card-btn" @click="openSettings('business', 'taxes')">Configurar
                            <span class="arrow">→</span></el-button>
                    </div>
                </div>

                <div class="config-card">
                    <div class="card-icon"><i class="bx bx-file"></i></div>
                    <div class="card-body">
                        <div class="card-title">Agrega tus políticas</div>
                        <div class="card-desc">Añade políticas de garantía, términos y condiciones</div>
                        <el-button type="primary" class="card-btn"
                            @click="openSettings('orderPreferences', 'policies')">Configurar <span
                                class="arrow">→</span></el-button>
                    </div>
                </div>

                <div class="config-card">
                    <div class="card-icon"><i class="bx bx-user"></i></div>
                    <div class="card-body">
                        <div class="card-title">Invita a tu equipo</div>
                        <div class="card-desc">Agrega técnicos y colaboradores a tu taller</div>
                        <el-button type="primary" class="card-btn" @click="openSettings('users', 'invite')">Configurar
                            <span class="arrow">→</span></el-button>
                    </div>
                </div>
            </div>

            <div class="configure-footer">
                <div class="footer-note">Podrás acceder a estas opciones en cualquier momento desde Configuración</div>
                <div class="footer-action"><el-button type="text" @click="continueAndClose">Continuar</el-button></div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { LOCAL_STORAGE_SAMII_KEYS, setItem } from '@/utils/storage';

export default {
    name: 'FifthStepOnboarding',
    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        visible: {
            get() {
                return this.show;
            },
            set(v) {
                if (!v) this.$emit('close');
            }
        }
    },
    methods: {
        openSettings(section, subsection) {
            this.$emit('open-settings', section, subsection);
        },
        continueAndClose() {
            setItem(LOCAL_STORAGE_SAMII_KEYS.ONBOARDING_CONFIGURE_STATUS, 'done');
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.onboarding-configure-dialog .el-dialog__body {
    padding: 0;
}

.onboarding-configure-body {
    padding: 28px 32px 24px;
    font-family: inherit;
}

.configure-header {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}

.configure-header-left {
    display: flex;
    gap: 12px;
    align-items: center;
}

.configure-icon {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    background: linear-gradient(180deg, #f6f0ff, #efe6ff);
    display: flex;
    align-items: center;
    justify-content: center;
}

.configure-icon i {
    font-size: 22px;
    color: #6d28d9;
}

.configure-title {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
}

.configure-sub {
    font-size: 13px;
    color: #6b7280;
}

.configure-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-top: 6px;
}

.config-card {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    padding: 18px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 16px rgba(17, 24, 39, 0.06);
    border: 1px solid rgba(15, 23, 42, 0.04);
    flex-direction: column;
}

.card-icon {
    width: 46px;
    height: 46px;
    border-radius: 8px;
    background: #f5f3ff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-icon i {
    font-size: 18px;
    color: #7c3aed;
}

.card-body {
    flex: 1;
}

.card-title {
    font-weight: 600;
    color: #111827;
    margin-bottom: 6px;
}

.card-desc {
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 12px;
}

.card-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: linear-gradient(90deg, #6d28d9, #8b5cf6);
    border: none;
    color: #fff;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px;
}

.card-btn .arrow {
    margin-left: 6px;
}

.configure-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    padding-top: 8px;
    border-top: 1px solid rgba(15, 23, 42, 0.04);
}

.footer-note {
    color: #6b7280;
    font-size: 13px;
}

.footer-action {}

@media (max-width: 720px) {
    .configure-grid {
        grid-template-columns: 1fr;
    }
}
</style>
